// extracted by mini-css-extract-plugin
export var banner = "_mb-0";
export var settingRow = "_mb-2";
export var titleIcon = "_mb-1";